var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('responsive-layout',{attrs:{"background":'bg-riseup-beige',"data-ls-disabled":""}})}
var staticRenderFns = []

export { render, staticRenderFns }